<template>
    <modal ref="files">
        <ListView
            ref="list"
            :inline="true"
            title="Choose file"
            :filter-func="item => this.allowedTypes.includes(item.type)"
            :show-id="false"
            :api-paging="false"
            :api-search="false"
            :api-list="require('@/common/api').default.storage"
            :columns="[
            { title: 'Name', name: 'name' },
            { title: 'Size', name: 'size', type: 'custom' },
            { title: 'Modified', name: 'modified', type: 'datetime', sortable: true }
        ]"
            use-folders>
            <template v-slot:top>
                <input style="display: none;" ref="file-upload" id="file_upload" type="file" multiple v-on:change="uploadFile($event.target.files)" />
                <label class="btn btn-primary" for="file_upload">Upload</label>
            </template>
            <template v-slot:custom="props">
                <div v-if="props.column.name === 'size'">
                <span v-if="props.item.size">
                    {{formatFileSize(props.item.size, 2)}}
                </span>
                </div>
            </template>
            <template v-slot:actions="{ selectedItem }">
                <button class="btn btn-primary" @click="close(selectedItem)">Select</button>
            </template>
        </ListView>
    </modal>
</template>
<script>
import { formatFileSize } from "../../utils/browser";
import ListView from "@/views/templates/ListView.vue";
import api from "@/common/api";

export default {
    components: { ListView },
    props: {
        allowedTypes: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            callback: null
        };
    },
    methods: {
        formatFileSize,
        open(callback) {
            this.callback = callback;
            this.$refs.files.open();
        },
        uploadFile(files) {
            const list = [];
            for (let i = 0; i < files.length; i++) {
                const f = files[i];
                list["file_" + i] = f;
            }

            this.loaded = false;
            api.storageUpload(list).then(data => {
                this.loaded = true;
                this.$refs.list.load();
                this.$refs["file-upload"].value = "";
            }).catch(e => {
                this.flashError(e);
                this.loaded = true;
            });
        },
        close(item) {
            if (this.callback && item) {
                this.callback(item, () => {
                    this.$refs.files.close();
                });
            } else {
                this.$refs.files.close();
            }
        }
    }
};
</script>
